module.exports = __webpack_public_path__ + "94a8e52f378efb7f1ce97bc9d450f2e3.MP3";